// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'
import { RadioTypeIdEnum } from 'config/enums'

export const initialValues = {
  acap: '',
  accp: '',
  architectureId: '',
  atpcFlag: '',
  atpcTypeId: '',
  company: '',
  createInfo: {},
  duplexModeId: '',
  dynamicPowerFlag: '',
  extNarrowBwFilter: '',
  hiFrequency: '',
  lastModifiedInfo: {},
  loFrequency: '',
  modulationLimit: '',
  modulationTypeId: '',
  powerTypeId: '',
  radioCode: '',
  radioModulations: null, // to avoid pass-by-reference when copying initialValues, just assign a new array
  radioTypeId: castToString(RadioTypeIdEnum.DIGITAL), // defaults to digital radio type
  specDate: '',
  stabilityId: '',
  statusId: '1', // Active hard coded as the default value
  xpic: '',
}
